import { FC } from 'react';
import { StyledButton } from '../shared/StyledButton';

type Props = {
  text?: string;
  onClick?: () => void;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
};

export const HeaderButton: FC<Props> = ({ text, onClick, color, backgroundColor, borderColor }) => {
  return (
    <StyledButton
      variant="none"
      type="submit"
      fontSize={1}
      color={color}
      borderStyle="solid"
      borderWidth="2px"
      borderColor={borderColor}
      borderRadius="3px 8px 3px 8px"
      backgroundColor={backgroundColor}
      onClick={onClick}
      margin="0px"
      lineHeight="18px"
      height={['35px', '40px']}
      padding={['0px 12px !important', '0px 16px !important']}
      width={['fit-content', '90px']}
    >
      {text}
    </StyledButton>
  );
};
